import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import about from "../../images/headshot.png"; // Replace with Taisha's photo
import client from "../../sanity/sanityClient";
import { urlFor } from "../../sanity/sanityClient"; // Ensure this is imported to resolve image URLs correctly.

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const BlogSidebar = (props) => {
  const [recentPosts, setRecentPosts] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    // Fetch recent posts from Sanity
    client
      .fetch(
        `*[_type == "post"] | order(publishedAt desc)[0...5] {
          _id,
          title,
          slug,
          publishedAt,
          mainImage
        }`
      )
      .then((data) => {
        setRecentPosts(data);
      })
      .catch((err) => console.error("Error fetching recent posts:", err));

    // Fetch categories from Sanity
    client
      .fetch(
        `*[_type == "category"] {
          _id,
          title
        }`
      )
      .then((data) => {
        setCategories(data);
      })
      .catch((err) => console.error("Error fetching categories:", err));
  }, []);

  return (
    <div className={`col col-lg-4 col-12 ${props.blLeft}`}>
      <div className="blog-sidebar">
        {/* About Widget */}
        <div className="widget about-widget">
          <div className="img-holder">
            <img src={about} alt="Taisha St. Jean Tard" />
          </div>
          <h4>Taisha St. Jean Tard</h4>
          <p>
            Hi! I’m Taisha, and I’m committed to building a stronger and more
            equitable Erie County. Follow my campaign journey and get involved!
          </p>
          <div className="social">
            <ul className="clearfix">
              <li>
                <a
                  href="https://www.facebook.com/profile.php?id=61568623033330"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                >
                  <i className="ti-facebook"></i>
                </a>
              </li>
              <li>
                <a
                  href="https://twitter.com/taishaforeriecounty"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Twitter"
                >
                  <i className="ti-twitter-alt"></i>
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/taishaforeriecounty/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                >
                  <i className="ti-instagram"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Recent Post Widget */}
        <div className="widget recent-post-widget">
          <h3>Recent Posts</h3>
          <div className="posts">
            {recentPosts.length > 0 ? (
              recentPosts.map((post) => (
                <div className="post" key={post._id}>
                  <div className="img-holder">
                    {post.mainImage ? (
                      <img
                        src={urlFor(post.mainImage)
                          .width(100)
                          .height(100)
                          .url()}
                        alt={post.title}
                      />
                    ) : (
                      <img
                        src="/placeholder-image.png" // Fallback image if none provided
                        alt="Placeholder"
                      />
                    )}
                  </div>
                  <div className="details">
                    <h4>
                      <Link
                        onClick={ClickHandler}
                        to={`/blog-single/${post.slug.current}`}
                      >
                        {post.title}
                      </Link>
                    </h4>
                    <span className="date">
                      {new Date(post.publishedAt).toLocaleDateString()}
                    </span>
                  </div>
                </div>
              ))
            ) : (
              <p>No recent posts available.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogSidebar;
